import { render } from "./PaywallVariantC.vue?vue&type=template&id=325cd23a&scoped=true"
import script from "./PaywallVariantC.vue?vue&type=script&lang=js"
export * from "./PaywallVariantC.vue?vue&type=script&lang=js"

import "./PaywallVariantC.vue?vue&type=style&index=0&id=325cd23a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\StrinGent\\Desktop\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325cd23a"]])

export default __exports__